import { selectClasses } from "@mui/material";
import React, { useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { CategoryBlackIcon, DeliveryBlackIcon, FullScreenBlackIcon, List3Icon, LogoutBlackIcon, LogoutRedIcon, PickupBlackIcon, ReservationBlackIcon, SettingsBlackIcon, TableBlackIcon } from "../../assets/icons";
import { useAuth } from "../../auth/AuthContext";

const LiveOrdersNavbar: React.FC = () => {

    const { localId } = useParams<{ localId: string }>();

    const { logout } = useAuth();

    return (
        <section className="live-order-navbar">
            <div className="w-layout-blockcontainer container live-order-navbar w-container">
                <div className="live-order-navbar-wrapper">
                    <div className="live-order-navbar-list-div">
                        <div className="div-block-67">

                            <NavLink
                                to={`/live-orders/${localId}/view1`}
                                className={({ isActive }) => isActive ? "live-order-navbar-div w-inline-block select" : "live-order-navbar-div w-inline-block"}
                            >
                                {({ isActive }) => (
                                    <>
                                        <div className="live-order-navbar-image-div">
                                            <img loading="lazy" src={TableBlackIcon} alt="" className="live-order-navbar-image" />
                                        </div>
                                        {!isActive && <div className="inactive-overlay-white"></div>}
                                    </>
                                )}

                            </NavLink>

                            <NavLink
                                to={`/live-orders/${localId}/view1-fullscreen`}
                                className={({ isActive }) => isActive ? "live-order-navbar-div w-inline-block select" : "live-order-navbar-div w-inline-block"}
                            >
                                {({ isActive }) => (
                                    <>
                                        <div className="live-order-navbar-image-div">
                                            <img loading="lazy" src={FullScreenBlackIcon} alt="" className="live-order-navbar-image" />
                                        </div>
                                        {!isActive && <div className="inactive-overlay-white"></div>}
                                    </>
                                )}

                            </NavLink>

                            <NavLink
                                to={`/live-orders/${localId}/dine-in`}
                                className={({ isActive }) => isActive ? "live-order-navbar-div w-inline-block select" : "live-order-navbar-div w-inline-block"}
                            >
                                {({ isActive }) => (
                                    <>
                                        <div className="live-order-navbar-image-div">
                                            <img loading="lazy" src={List3Icon} alt="" className="live-order-navbar-image" />
                                        </div>
                                        {!isActive && <div className="inactive-overlay-white"></div>}
                                    </>
                                )}

                            </NavLink>

                            <NavLink
                                to={`/live-orders/${localId}/pickup`}
                                className={({ isActive }) => isActive ? "live-order-navbar-div w-inline-block select" : "live-order-navbar-div w-inline-block"}
                            >
                                {({ isActive }) => (
                                    <>
                                        <div className="live-order-navbar-image-div">
                                            <img loading="lazy" src={PickupBlackIcon} alt="" className="live-order-navbar-image" />
                                        </div>
                                        {!isActive && <div className="inactive-overlay-white"></div>}
                                    </>
                                )}

                            </NavLink>

                            <NavLink
                                to={`/live-orders/${localId}/delivery`}
                                className={({ isActive }) => isActive ? "live-order-navbar-div w-inline-block select" : "live-order-navbar-div w-inline-block"}
                            >
                                {({ isActive }) => (
                                    <>
                                        <div className="live-order-navbar-image-div">
                                            <img loading="lazy" src={DeliveryBlackIcon} alt="" className="live-order-navbar-image" />
                                        </div>
                                        {!isActive && <div className="inactive-overlay-white"></div>}
                                    </>
                                )}

                            </NavLink>

                        </div>

                        <div className="div-block-67">

                            <NavLink
                                to={`/live-orders/${localId}/reservation`}
                                className={({ isActive }) => isActive ? "live-order-navbar-div w-inline-block select" : "live-order-navbar-div w-inline-block"}
                            >
                                {({ isActive }) => (
                                    <>
                                        <div className="live-order-navbar-image-div">
                                            <img loading="lazy" src={ReservationBlackIcon} alt="" className="live-order-navbar-image" />
                                        </div>
                                        {!isActive && <div className="inactive-overlay-white"></div>}
                                    </>
                                )}

                            </NavLink>

                            <NavLink
                                to={`/live-orders/${localId}/tables-position/view1`}
                                className={({ isActive }) => isActive ? "live-order-navbar-div w-inline-block select" : "live-order-navbar-div w-inline-block"}
                            >
                                {({ isActive }) => (
                                    <>
                                        <div className="live-order-navbar-image-div">
                                            <img loading="lazy" src={TableBlackIcon} alt="" className="live-order-navbar-image" />
                                            <img src={SettingsBlackIcon} loading="lazy" alt="" className="live-order-navbar-image-settings" />
                                        </div>
                                        {!isActive && <div className="inactive-overlay-white"></div>}
                                    </>
                                )}

                            </NavLink>

                            <NavLink
                                to={`/live-orders/${localId}/tables-position/view1-fullscreen`}
                                className={({ isActive }) => isActive ? "live-order-navbar-div w-inline-block select" : "live-order-navbar-div w-inline-block"}
                            >
                                {({ isActive }) => (
                                    <>
                                        <div className="live-order-navbar-image-div">
                                            <img loading="lazy" src={FullScreenBlackIcon} alt="" className="live-order-navbar-image" />
                                            <img src={SettingsBlackIcon} loading="lazy" alt="" className="live-order-navbar-image-settings" />
                                        </div>
                                        {!isActive && <div className="inactive-overlay-white"></div>}
                                    </>
                                )}

                            </NavLink>

                        </div>
                    </div>

                    <div className="live-order-logout-div" >
                        <div className="live-order-logout-image-div live-order-navbar-div" onClick={logout}>
                            <img loading="lazy" src={LogoutRedIcon} alt="" className="live-order-logout-image" />
                        </div>
                    </div>

                </div>
            </div>
        </section>

    )
};

export default LiveOrdersNavbar;